/**
 * Per-event-type state of the booking page in `sessionStorage` (the hold key and the form survive a
 * reload and a race, B2 „For F2"). Storage can be unavailable (private mode) — the page then keeps the
 * state in memory only.
 */

const PREFIX = 'brimo.booking';

function key(scope: string, name: string): string {
  return `${PREFIX}.${scope}.${name}`;
}

export function readStored<T>(scope: string, name: string): T | null {
  try {
    const raw = window.sessionStorage.getItem(key(scope, name));
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function writeStored(scope: string, name: string, value: unknown): void {
  try {
    window.sessionStorage.setItem(key(scope, name), JSON.stringify(value));
  } catch {
    // Storage is optional: the state stays in memory.
  }
}

export function removeStored(scope: string, name: string): void {
  try {
    window.sessionStorage.removeItem(key(scope, name));
  } catch {
    // Nothing stored.
  }
}
